import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { Localization } from 'bernie-l10n';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { useLodgingURLParamsToQueryInputs } from '@shared-ui/search-tools-lodging';

import { getPropertySearchInput } from 'stores/adapters';
import { hasStoresChanged } from 'stores/utils';
import { SearchCriteriaModel } from 'stores/models';
import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';

import { UitkSpacing } from 'uitk-react-spacing';

import { CustomerNotifications } from '../../common/customer-notifications';
import { OneKeyBannerToggle } from 'components/common/one-key-banner-toggle';
import { Pagination } from 'components/search/pagination/pagination';
import { PropertyListingWrapper, PropertyListingWrapperProps } from '../property-listing/property-listing-wrapper';

export const PropertySearchListings = inject(
  'context',
  'experiment',
  'multiItem',
  'searchCriteria',
  'searchResults'
)(
  observer(({ context, experiment, multiItem, searchCriteria, searchResults }: PropertyListingWrapperProps) => {
    const lodgingQueryInputs = useLodgingURLParamsToQueryInputs();

    if (!context || !searchCriteria || !searchResults) {
      return null;
    }
    const searchInputs = getPropertySearchInput(context, searchCriteria, multiItem?.multiItemContext);

    const rooms = lodgingQueryInputs?.propertySearchCriteriaInput?.primary.rooms;
    if (searchInputs?.criteria?.primary && rooms) {
      searchInputs.criteria.primary.rooms = rooms;
    }

    const modelData = SearchQueryAdapter.parseIn(searchCriteria.toJSON());
    const incomingSearchCriteria = new SearchCriteriaModel(modelData, new Localization(context.locale));
    const criteriaChanged = hasStoresChanged(searchResults.searchCriteria, incomingSearchCriteria);

    const useSharedUIListingsQuery =
      !multiItem?.isPackageShoppingPath() && experiment?.exposures?.EG_Property_Search_Query_Migration?.bucket === 1;

    return (
      <div data-stid="section-results">
        <Experiment name="One_Key_Main_Gate">
          <ExperimentControl />
          <ExperimentVariant bucket={1}>
            <UitkSpacing margin={{ block: 'two' }}>
              <div>
                <CustomerNotifications location={CustomerNotificationLocation.IN_PAGE} />
              </div>
            </UitkSpacing>
          </ExperimentVariant>
        </Experiment>
        <Experiment name="BEX_mweb_PTP_inline_MAD_LSR_main_Gate">
          <ExperimentControl />
          <ExperimentVariant bucket={1}>
            <UitkSpacing margin={{ block: 'two' }}>
              <div>
                <CustomerNotifications location={CustomerNotificationLocation.IN_PAGE} />
              </div>
            </UitkSpacing>
          </ExperimentVariant>
        </Experiment>
        <OneKeyBannerToggle />
        <PropertyListingWrapper searchInputs={searchInputs} criteriaChanged={criteriaChanged} />
        {useSharedUIListingsQuery ? <></> : <Pagination />}
      </div>
    );
  })
);
